import ReportWrapperPage from '../ReportWrapperPage';

export default ReportWrapperPage;
